import { Collapse, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const ErrorText = styled(Typography)(({ theme }) => ({
  color: 'var(--canvas-error, ' + theme.palette.error.main + ')',
  fontSize: '0.75rem',
  fontWeight: 500,
  letterSpacing: '0.01em',
  marginTop: theme.spacing(0.5),
  marginLeft: 2,
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeInOut,
  }),
}));

const FieldError = ({ error, touched }) => (
  <Collapse in={touched && !!error}>
    <ErrorText role="alert">{error}</ErrorText>
  </Collapse>
);

export default React.memo(FieldError);
